import { Field } from 'formik';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import DatePicker from 'react-datepicker';
import ErrorIcon from './ErrorIcon';

interface DateInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
}

const DateInput = ({ name, label, ...props }: DateInputProps) => (
  <Field name={name}>
    {({ field, meta: { error, touched }, form: { setFieldValue } }) => (
      <>
        {label && (
          <label
            htmlFor={name}
            className={`u-label ${touched && error && 'u-label--error'}`}
          >
            {label}
          </label>
        )}
        <div className="relative inline-flex w-full">
          <DatePicker
            id={name}
            className={`w-full u-input ${touched && error && 'u-input--error'}`}
            dateFormat="MM/dd/yy"
            placeholderText={props.placeholder}
            minDate={new Date()}
            showPopperArrow={false}
            locale="en-US"
            formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 3)}
            selected={field.value}
            popperPlacement="bottom-start"
            popperModifiers={[
              {
                name: 'offset',
                options: {
                  offset: [0, 15],
                },
              },
            ]}
            onChange={(date) => {
              setFieldValue(name, date);
            }}
          />
          <AnimatePresence>
            {touched && error && (
              <ErrorIcon className="absolute right-0 mr-4 -mt-3 pointer-events-none top-1/2" />
            )}
          </AnimatePresence>
        </div>
        <AnimatePresence>
          {touched && error && (
            <motion.div
              className="text-red-accessibility pt-0.5"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
            >
              {error}
            </motion.div>
          )}
        </AnimatePresence>
      </>
    )}
  </Field>
);

export default DateInput;
